export class FetchProjectsAction {
  static readonly type = '[Project] Fetch Projects';

  constructor() {}
}
